import React, { Component } from 'react'
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import  BreadCrumb  from "app/components/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useInjectReducer } from "redux-injectors";
import { ActionBar } from "./components/ActionBar"
import { reducer, sliceKey } from './redux/slice';

import { useStyles } from "./styles";
import AdminManagementTable from "./components/AdminMangementTable/index"
import {
  selectIsLoading,
  selectError,
  selectFilteredData
} from "./redux/selector";
import { adminManagementTableRow } from './types';

const AdminManagement = () => {
const styles = useStyles();
const { t, i18n } = useTranslation();
const loading: boolean = useSelector(selectIsLoading) 
const rows: adminManagementTableRow[] = useSelector(selectFilteredData) 

useInjectReducer({
  key: sliceKey,
  reducer,
});


  return (<Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <BreadCrumb title={t("SIDEBAR.USER_MANAGEMENT")} iconPosition="end" />
          <ActionBar/>
          <AdminManagementTable rows={rows} loading={loading} />
        </Box>
    </Box>
  )
}

export default AdminManagement
